//数据类型
const DataType = {
    TEXT: 0,                // 文本框
    TEXT_AREA: 1,           // 多行文本框
    MOBILE_PHON: 2,         // 手机
    LAND_LINE: 3,           // 座机
    EMAIL: 4,               // 邮箱
    NUMBER: 5,              // 数值
    CERTIFICATES: 6,        // 证件
    AMOUNT: 7,              // 数量
    RADIO: 8,               // 单选框
    CHECK_BOX: 9,           // 多选框
    SELECT: 10,             // 多选框
    PERSONNEL: 11,          // 单成员
    PEOPLE: 12,             // 多成员
    ATTACHMENT: 13,         // 附件
    DATE: 14,               // 日期
    TIME: 15,               // 时间
    DATE_TIME: 16,          // 日期和时间
    DATE_SPAN: 17,          // 日期段
    DATE_TIME_SPAN: 18,     // 日期时间段
    DISTRICT1: 19,          // 地区(省)
    FORMULA: 20,            // 公式
    RELATION: 21,           // 自由连接
    SPLIT_LINE: 22,         // 分段
    DISTRICT2: 23,          // 地区(省-市)
    DISTRICT3: 24,          // 地区(省-市-县)
    BIG_AMOUNT: 25,         // 大写金额
    USER_SELECT: 26,        // 人员
    DEPARTMENT_SELECT: 27,  // 部门
    SCORE: 28,              // 等级
    RELATION_WORKSHEET: 29, // 表关联
    RELATION_WS_COLUMN: 30, // 关联表字段
    WS_FORMULA: 31,         // 工作表公式
    FORMULA_STRING: 32,     // 文本拼接
    INCREASE: 33,           // 自动编号
    DETAIL_TABLE: 34,       // 子表
    CASCADE: 35,            // 级联选择
    CHECK_RADIO: 36,        // 检查框
    SUMMARY: 37,            // 汇总
    FORMULA_DATE: 38,       // 公式(日期)
    SCAN_CODE: 39,          // 扫码
    LOCATION: 40,           // 定位
    RICH_TEXT: 41,          // 富文本
    SIGNATURE: 42,          // 签名
    RATE: 43,               // 评分
    SLIDER: 44,             // 滑动输入条
    UPLOAD_FILE: 45,        // 上传文件
    UPLOAD_IMG: 46,         // 上传图片
    TREE_SELECT: 47,        // 树选择器
    BATCH: 48,              // 动态表格
    SWITCH: 49,             // 开关
    BUTTON: 50,             // 按钮
    ALERT: 51,              // 警告提示
    TEXT_FONT: 52,          // 文字
    HTML: 53,                // HTML
    CURLOC: 62,                // 签到
    MEMBER: 63,                // 成员
    CURRENTTIME: 64,                // 当前时间
};

//连接类型
const SpliceType = {
    AND: 0,
    OR: 1
}

const FilterType = {
    DEFAULT: 0,             //默认
    INCLUDE: 1,             //包含
    EQUAL: 2,               //是（等于）
    BEGAIN: 3,              //开头为
    END: 4,                 //结尾为
    EXCLUSIVE: 5,           //不包含
    UNEQUAL: 6,             //不是（不等于）
    GREATER: 12,            //>
    GREATER_EQUAL: 13,      //>=
    LESS: 14,               //<
    LESS_EQUAL: 15,         //<=
    DATE_YES: 16,           //日期是
    DATE_NO: 17             //日期不是
}

const DateRange = {
    DEFAULT: 0,                     //默认
    TODAY: 1,                       //今天
    YESTERDAY: 2,                   //昨天
    TOMORROW: 3,                   //明天
    THIS_WEEK: 4,                   //本周
    LAST_WEEK: 5,                   //上周
    NEXT_WEEK: 6,                   //下周
    THIS_MONTH: 7,                  //本月
    LAST_MONTH: 8,                  //上月
    NEXT_MONTH: 9,                  //下月
    PAST_SEVERAL_DAYS: 10,          //过去...天
    FEATURE_SEVERAL_DAYS: 11,       //将来...天
    CUSTOM_DAYS: 18                 //自定义
}

export { DataType, SpliceType, FilterType, DateRange };